/**
 * I9 Data Mapping
 * Based on https://quip-amazon.com/6QQmAzHGXBe2/CaaS-Real-Time-Status
 */
export enum I9ButtonState {
  Active = "Active",
  Hidden = "Hidden",
  Disabled = "Disabled",
}

export enum I9Type {
  Normal = "Normal",
  Remote = "Remote",
}

//translate this part to get from bundle
const AshStatusPendingSection1Required =
  "Checklist-MainPage-I9-PendingSection1";
const AshStatusPendingSection1 = "Checklist-MainPage-I9-PendingSection1Short";
const AshStatusPendingSection2 = "Checklist-MainPage-I9-PendingSection2";
const AshStatusPendingSection2Required =
  "Checklist-MainPage-I9-PendingSection2Action";
const AshStatusComplete = "checklist-General-TaskStatus-Completed";
const AshPendingSection3 = "Checklist-MainPage-I9-PendingSection3Short";
const AshStatusEmpty = "";

export const MessageYouMustCompleteSection1 =
  "Checklist-MainPage-I9-YouMustCompleteSection1Message";
const MessageThanksForCompletingSection1 =
  "Checklist-MainPage-I9-CompletedSection1Message";

const MessageThanksForCompletingI9 = "Checklist-MainPage-I9-ThankYouMessage";

const MessageAlreadyCompleted =
  "Checklist-MainPage-I9-AlreadyCompletedDetailedMessage";

const MessageThanksForCompletingSection1Remote =
  "Checklist-MainPage-I9-ThanksForCompletingSection1RemoteMessage";

const CAAS_STATUS_TO_MESSAGE = {
  Initiated: MessageYouMustCompleteSection1,
  WaitingForASHToCreateOrder: MessageYouMustCompleteSection1,
  PendingSection1: MessageYouMustCompleteSection1,
  Section1Complete: MessageThanksForCompletingSection1,
  Section2Complete: MessageThanksForCompletingI9,
  PendingSection3: MessageAlreadyCompleted,
  Section3Complete: MessageThanksForCompletingI9,
  "Remote+Section1Complete": MessageThanksForCompletingSection1Remote,
  Archived: MessageAlreadyCompleted,
};

const CAAS_STATUS_TO_BUTTON_STATE = {
  Initiated: I9ButtonState.Active,
  WaitingForASHToCreateOrder: I9ButtonState.Active,
  PendingSection1: I9ButtonState.Active,
  Section1Complete: I9ButtonState.Disabled,
  Section2Complete: I9ButtonState.Disabled,
  PendingSection3: I9ButtonState.Hidden,
  Section3Complete: I9ButtonState.Disabled,
  Archived: I9ButtonState.Hidden,
};

const CAAS_STATUS_TO_ASH_STATUS: Record<string, string> = {
  Initiated: AshStatusPendingSection1Required,
  WaitingForASHToCreateOrder: AshStatusPendingSection1Required,
  PendingSection1: AshStatusPendingSection1Required,
  Section1Complete: AshStatusPendingSection2,
  Section2Complete: AshStatusComplete,
  PendingSection3: AshPendingSection3,
  Section3Complete: AshStatusComplete,
  "Remote+PendingSection1": AshStatusPendingSection1,
  "Remote+Section1Complete": AshStatusPendingSection2Required,
  "Remote+PendingSection3": AshStatusComplete,
  Archived: AshStatusEmpty,
};

const getAshEntity = (
  i9Type: I9Type,
  caasStatus: string,
  dictionary: any
): string => {
  const specificKey = `${i9Type}+${caasStatus}`;
  const commonKey = caasStatus;
  return dictionary[specificKey] || dictionary[commonKey];
};

export const getAshStatus = (i9Type: I9Type, caasStatus: string): string => {
  return getAshEntity(i9Type, caasStatus, CAAS_STATUS_TO_ASH_STATUS);
};

export const getAshButtonState = (
  i9Type: I9Type,
  caasStatus: string
): I9ButtonState => {
  return getAshEntity(
    i9Type,
    caasStatus,
    CAAS_STATUS_TO_BUTTON_STATE
  ) as I9ButtonState;
};

export const getAshMessage = (i9Type: I9Type, caasStatus: string): string => {
  return getAshEntity(i9Type, caasStatus, CAAS_STATUS_TO_MESSAGE);
};
